import { render, staticRenderFns } from "./personSetDialog.vue?vue&type=template&id=d2d7e8b4&scoped=true&"
import script from "./personSetDialog.vue?vue&type=script&lang=js&"
export * from "./personSetDialog.vue?vue&type=script&lang=js&"
import style0 from "./personSetDialog.vue?vue&type=style&index=0&id=d2d7e8b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d7e8b4",
  null
  
)

export default component.exports